import Login from "../components/pages/login/LoginPage";
import PreEnrollmentInvited from "../components/pages/landingRoutes/PreEnrollmentInvitedPage";
import PreEnrollment from "../components/pages/landingRoutes/PreEnrollmentPage";
import ResetPasswordPage from "../components/pages/login/ResetPasswordPage";
import EmptyPage from "../components/pages/generic/EmptyPage";
import Page404 from "../components/pages/generic/Page404";
import PreEnrollmentUserInvite from "../components/pages/landingRoutes/PreEnrollmentUserInvite";
import PreEnrollmentFS from "../components/pages/landingRoutes/PreEnrollmentFSPage";

const routes = [
    {
        path: "/*",
        element: <Page404 />
    },
    {
        path: "/",
        element: <EmptyPage />
    },
    {
        path: "/login",
        element: <Login />
    },
    {
        path: "/login/:inviteID",
        element: <Login />
    },
    {
        path: "/pre-enrollment-user",
        element: <PreEnrollmentUserInvite />
    },
    {
        path: "/pre-enrollment-user/:inviteID",
        element: <PreEnrollmentUserInvite />
    },
    {
        path: "/resetpassword",
        element: <ResetPasswordPage />
    },
    {
        path: "/pre-enrollment-invited",
        element: <PreEnrollmentInvited showThankRedirectedYouOnLoad={false} />
    },
    {
        path: "/pre-enrollment-invited/:inviteID",
        element: <PreEnrollmentInvited showThankRedirectedYouOnLoad={false} />
    },
    {
        path: "/pre-enrollment",
        element: <PreEnrollment showThankRedirectedYouOnLoad={false} />
    },
    {
        path: "/pre-enrollment-fs",
        element: <PreEnrollmentFS showThankRedirectedYouOnLoad={false} />
    },
    {
        path: "/pre-enrollment/thank-you",
        element: <PreEnrollment showThankRedirectedYouOnLoad={true} />
    }
];

export default routes;
